/** Gmail, send only: the digest. The `gmail.send` scope cannot read mail. */
import { api } from './api'

/** Sends a base64url-encoded RFC 2822 message as the signed-in user. */
export async function sendMail(raw: string): Promise<void> {
  await api.post('https://gmail.googleapis.com/gmail/v1/users/me/messages/send', { raw })
}
